export enum PolishStatus {
  IN_POLISH_FLOW = '0',
}
